window.LusInternational.ready.then(() => {
(() => {
  if (window.__luscentraRefillMounted) return;
  window.__luscentraRefillMounted = true;

  const normalise = value => (value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const modelFromText = value => normalise(value).includes('wall') ? 'wall-mount' : normalise(value).includes('hand') ? 'handheld' : '';
  const modelLabel = model => model === 'wall-mount' ? 'Wall Mount' : 'Handheld';
  const modelNeedle = model => model === 'wall-mount' ? 'wall' : 'hand';
  const knownScents = ['neutral', 'citrus', 'lavender', 'jasmine', 'rose'];

  function formatPrice(cents) {
    const currency = window.Shopify?.currency?.active || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency, maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2
      }).format(Number(cents) / 100);
    } catch (_) { return `${currency} ${(Number(cents) / 100).toFixed(2)}`; }
  }

  function cardVariant(product, model, scent) {
    const variants = product?.variants || [];
    const matches = variants.filter(item => modelFromText([item.title, ...(item.options || [])].join(' ')) === model);
    const hasScents = variants.some(item => knownScents.some(value => normalise([item.title, ...(item.options || [])].join(' ')).includes(value)));
    if (!hasScents) return matches.find(item => item.available) || matches[0];
    const wantedScent = knownScents.includes(normalise(scent)) ? normalise(scent) : 'citrus';
    return matches.find(item => normalise([item.title, ...(item.options || [])].join(' ')).includes(wantedScent)) || matches[0];
  }

  function cardImage(variant, product, model = '', scent = '') {
    const landscapeKey = model && scent ? `${model}-${normalise(scent)}` : '';
    if (landscapeKey && product?.landscape_images?.[landscapeKey]) return product.landscape_images[landscapeKey];
    if (typeof variant?.featured_image === 'string') return variant.featured_image;
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (typeof product?.featured_image === 'string') return product.featured_image;
    if (product?.featured_image?.src) return product.featured_image.src;
    if (product?.image) return product.image;
    return product?.images?.[0] || '';
  }

  async function freshCartPayload(drawer, addedVariantId) {
    const root = window.Shopify?.routes?.root || '/';
    const sectionIds = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-drawer', 'cart-icon-bubble'];
    const sectionsUrl = new URL(root, location.origin);
    sectionsUrl.searchParams.set('sections', sectionIds.join(','));
    const [sectionsResponse, cartResponse] = await Promise.all([
      fetch(sectionsUrl.toString(), {headers: {Accept: 'application/json'}, cache: 'no-store'}),
      fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'}),
    ]);
    if (!sectionsResponse.ok || !cartResponse.ok) throw new Error('Cart refresh failed');
    const [sections, cart] = await Promise.all([sectionsResponse.json(), cartResponse.json()]);
    return {...cart, id: addedVariantId, sections};
  }

  function productModel(root) {
    const values = [...root.querySelectorAll('input[type="radio"]:checked, select option:checked')].map(node => node.value || node.textContent).join(' ');
    return modelFromText(values) || modelFromText(root.querySelector('.product__title')?.textContent) || 'handheld';
  }

  function hasModelChoice(root) {
    return [...root.querySelectorAll('input[type="radio"], select option')].some(node => modelFromText(node.value || node.textContent));
  }

  function productVariants(root) {
    try { return JSON.parse(root.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]')?.textContent || '[]'); } catch (_) { return []; }
  }

  function optionSelectedVariant(root, variants) {
    const selected = [...root.querySelectorAll('input[type="radio"]:checked, select option:checked')]
      .map(node => normalise(node.value || node.textContent));
    if (!selected.length) return null;
    return variants.find(variant => (variant.options || []).every(option => selected.includes(normalise(option)))) || null;
  }

  function requestedVariant(root, model, scent) {
    const selectedValues = [...root.querySelectorAll('input[type="radio"]:checked, select option:checked')].map(node => normalise(node.value || node.textContent)).filter(value => !modelFromText(value));
    const wantedScent = normalise(scent) || selectedValues.find(value => ['neutral', 'citrus', 'lavender', 'jasmine', 'rose'].includes(value)) || 'citrus';
    const matches = productVariants(root).filter(variant => modelFromText([variant.title, ...(variant.options || [])].join(' ')) === model);
    return matches.find(variant => normalise([variant.title, ...(variant.options || [])].join(' ')).includes(wantedScent)) || matches[0];
  }

  function chooseModel(root, model) {
    const input = [...root.querySelectorAll('input[type="radio"]')].find(node => modelFromText(node.value) === model);
    if (input && !input.checked) { input.click(); return true; }
    const select = [...root.querySelectorAll('select')].find(element => [...element.options].some(option => modelFromText(option.value || option.textContent) === model));
    if (select) {
      const option = [...select.options].find(item => modelFromText(item.value || item.textContent) === model);
      if (option && select.value !== option.value) { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); return true; }
    }
    return false;
  }

  function timing(type, model) {
    if (type === 'vitamin-c') return model === 'wall-mount' ? 'Typically 4–6 months.' : 'Typically 2–3 months.';
    if (type === 'microfibre') return 'Check regularly, typically around one month.';
    return 'Typically around six months.';
  }

  function syncRoutine(routine, model, scent = 'citrus') {
    routine.dataset.refillModel = model;
    routine.querySelectorAll('[data-refill-model-label]').forEach(node => { node.textContent = modelLabel(model); });
    routine.querySelectorAll('[data-refill-model-button]').forEach(button => button.setAttribute('aria-checked', String(button.dataset.refillModelButton === model)));
    routine.querySelectorAll('[data-refill-card]').forEach(card => {
      let variant, product;
      try {
        product = JSON.parse(card.querySelector('[data-refill-card-product]')?.textContent || '{}');
        variant = cardVariant(product, model, scent);
      } catch (_) {}
      if (product) {
        const title = card.querySelector('[data-refill-card-title]');
        const price = card.querySelector('[data-refill-card-price]');
        const modelNode = card.querySelector('[data-refill-card-model]');
        const availability = card.querySelector('[data-refill-card-availability]');
        const image = card.querySelector('.lus-refill-card__media img');
        if (title) title.textContent = product.title;
        if (price && variant?.price != null) price.textContent = (window.LusInternational.mode === 'india' ? formatPrice(variant.price) : window.LusInternational.price(variant, product));
        if (modelNode) modelNode.textContent = modelLabel(model);
        if (availability) availability.textContent = variant?.available ? 'In stock' : 'Unavailable';
        const imageUrl = cardImage(variant, product, model, scent);
        if (image && imageUrl) { image.removeAttribute('srcset'); image.src = imageUrl; image.alt = `${product.title}: ${modelLabel(model)}${scent ? `, ${scent}` : ''}`; }
        card.dataset.selectedVariant = variant?.id || '';
        card.dataset.selectedAvailable = String(Boolean(variant?.available));
      }
      card.querySelectorAll('[data-refill-link]').forEach(link => {
        const url = new URL(product?.url || link.href, location.origin);
        url.searchParams.set('model', model);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        if (variant && knownScents.some(value => normalise([variant.title, ...(variant.options || [])].join(' ')).includes(value))) url.searchParams.set('scent', normalise(scent) || 'citrus');
        else url.searchParams.delete('scent');
        link.href = `${url.pathname}${url.search}`;
      });
    });
    routine.querySelectorAll('.lus-refill__all [data-refill-link]').forEach(link => {
      const url = new URL(link.href, location.origin); url.searchParams.set('model', model); link.href = `${url.pathname}${url.search}`;
    });
  }

  function syncPage(model, scent = 'citrus') {
    document.querySelectorAll('[data-refill-model-label]').forEach(node => { if (!node.closest('[data-refill-routine]')) node.textContent = modelLabel(model); });
    document.querySelectorAll('[data-refill-timing]').forEach(node => { node.textContent = timing(node.closest('[data-refill-type]')?.dataset.refillType || 'vitamin-c', model); });
    document.querySelectorAll('[data-refill-compatibility]').forEach(node => {
      if (node.dataset.refillCompatibility === 'short') node.textContent = `This selection is for the Luscentra ${modelLabel(model)} system. Choose the model shown above before adding it to your bag.`;
      else node.textContent = model === 'wall-mount' ? 'Designed for the Luscentra Wall Mount system. The showerhead fits any standard 1/2-inch threaded shower arm.' : 'Designed for the Luscentra Handheld system. The showerhead fits any standard 1/2-inch threaded shower hose.';
    });
    document.querySelectorAll('[data-refill-routine]').forEach(routine => syncRoutine(routine, model, scent));
    try { sessionStorage.setItem('luscentra-model', model); } catch (_) {}
  }

  function selectedVariant(root) {
    const id = root.querySelector('.product-variant-id')?.value;
    const variants = productVariants(root);
    const queryId = new URLSearchParams(location.search).get('variant');
    return variants.find(item => String(item.id) === String(id))
      || variants.find(item => String(item.id) === String(queryId))
      || optionSelectedVariant(root, variants);
  }

  function selectedScent(root) {
    const checked = [...root.querySelectorAll('input[type="radio"]:checked, select option:checked')]
      .map(node => normalise(node.value || node.textContent));
    return checked.find(value => ['neutral', 'citrus', 'lavender', 'jasmine', 'rose'].includes(value)) || '';
  }

  function syncVisualSelectors(root, model) {
    root.querySelectorAll('[data-refill-tile-model]').forEach(media => {
      media.hidden = media.dataset.refillTileModel !== model;
    });
  }

  function syncVariantUrl(root, model) {
    const variant = selectedVariant(root);
    if (!variant) return;
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('model', model);
    const scent = selectedScent(root);
    if (scent) url.searchParams.set('scent', scent);
    else url.searchParams.delete('scent');
    history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  function syncCapsuleGallery(root, model, scent) {
    if (root.dataset.refillType !== 'vitamin-c' || !knownScents.includes(scent)) return;
    let config;
    try { config = JSON.parse(document.querySelector('[data-refill-bundle-config]')?.textContent || '{}'); } catch (_) { return; }
    const imageUrl = config?.products?.capsule?.landscape_images?.[`${model}-${scent}`];
    if (!imageUrl) return;
    const image = root.querySelector('media-gallery .product__media-item.is-active img') || root.querySelector('media-gallery .product__media-item img');
    if (!image) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = imageUrl;
    image.alt = `Luscentra ${modelLabel(model)} Vitamin C capsule, ${scent}`;
  }

  class LuscentraRefillPdpBundle extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mounted === 'true') return;
      this.dataset.mounted = 'true';
      try { this.config = JSON.parse(this.querySelector('[data-refill-bundle-config]')?.textContent || '{}'); } catch (_) { return; }
      this.itemsNode = this.querySelector('[data-refill-bundle-items]');
      this.pricingNode = this.querySelector('[data-refill-bundle-pricing]');
      this.modelNode = this.querySelector('[data-refill-bundle-model]');
      this.scentWrap = this.querySelector('[data-refill-bundle-scent-wrap]');
      this.scentSelect = this.querySelector('[data-refill-bundle-scent]');
      this.button = this.querySelector('[data-refill-bundle-add]');
      this.status = this.querySelector('[data-refill-bundle-status]');
      this.currentCategory = this.dataset.currentCategory;
      this.model = ['handheld', 'wall-mount'].includes(this.dataset.initialModel) ? this.dataset.initialModel : 'handheld';
      this.requirements = {capsule: 1, microfibre: 1, ceramic: 1, ...(this.config.requirements || {})};
      this.scent = this.currentCategory === 'capsule' ? 'citrus' : '';
      this.scentSelect?.addEventListener('change', () => {
        this.scent = this.scentSelect.value;
        this.render();
      });
      this.button?.addEventListener('click', () => this.addSet());
      this.render();
    }

    sync(model, scent, currentVariant) {
      this.model = model;
      this.currentVariant = currentVariant;
      if (knownScents.includes(normalise(scent))) this.scent = normalise(scent);
      this.render();
    }

    selectedVariants() {
      return ['capsule', 'microfibre', 'ceramic'].map(category => {
        const product = this.config?.products?.[category];
        let variant = category === this.currentCategory ? this.currentVariant : null;
        if (category === 'capsule' && this.currentCategory !== 'capsule' && !knownScents.includes(this.scent)) {
          variant = cardVariant(product, this.model, 'citrus') || cardVariant(product, this.model, '');
        } else if (!variant || modelFromText([variant.title, ...(variant.options || [])].join(' ')) !== this.model) {
          variant = cardVariant(product, this.model, category === 'capsule' ? this.scent : '');
        }
        return { category, product, variant };
      });
    }

    renderScent() {
      if (!this.scentWrap || !this.scentSelect) return;
      this.scentWrap.hidden = this.currentCategory === 'capsule';
      if (this.currentCategory === 'capsule') return;
      const capsule = this.config?.products?.capsule;
      const variants = (capsule?.variants || []).filter(variant => modelFromText([variant.title, ...(variant.options || [])].join(' ')) === this.model);
      this.scentSelect.replaceChildren();
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select a scent';
      placeholder.disabled = true;
      placeholder.selected = !knownScents.includes(this.scent);
      this.scentSelect.append(placeholder);
      variants.forEach(variant => {
        const identity = normalise([variant.title, ...(variant.options || [])].join(' '));
        const scent = knownScents.find(value => identity.includes(value)) || variant.title;
        const option = document.createElement('option');
        option.value = scent;
        option.textContent = scent.charAt(0).toUpperCase() + scent.slice(1);
        option.disabled = !variant.available;
        option.selected = scent === this.scent;
        this.scentSelect.append(option);
      });
    }

    render() {
      if (!this.config || !this.itemsNode || !this.pricingNode) return;
      this.renderScent();
      const selections = this.selectedVariants();
      if (this.modelNode) this.modelNode.textContent = modelLabel(this.model);
      this.itemsNode.replaceChildren();
      const labels = {capsule: 'Vitamin C capsule', microfibre: 'Microfibre filter', ceramic: 'Ceramic filter'};
      selections.forEach(({category, product, variant}) => {
        const item = document.createElement('article');
        item.className = 'lus-refill-bundle__item';
        const media = document.createElement('span');
        media.className = 'lus-refill-bundle__media';
        const imageUrl = cardImage(variant, product, this.model, category === 'capsule' ? this.scent : '');
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 88;
          image.height = 88;
          media.append(image);
        }
        const copy = document.createElement('span');
        copy.className = 'lus-refill-bundle__item-copy';
        const title = document.createElement('strong');
        title.textContent = labels[category];
        const detail = document.createElement('span');
        const scent = category === 'capsule' && knownScents.includes(this.scent) ? this.scent : '';
        detail.textContent = `${modelLabel(this.model)}${scent ? ` · ${scent.charAt(0).toUpperCase() + scent.slice(1)}` : ''}`;
        copy.append(title, detail);
        const price = document.createElement('span');
        price.className = 'lus-refill-bundle__item-price';
        const quantity = Number(this.requirements[category] || 1);
        price.textContent = quantity > 1 ? `${quantity} × ${formatPrice(variant?.price || 0)}` : formatPrice(variant?.price || 0);
        item.append(media, copy, price);
        this.itemsNode.append(item);
      });
      const original = selections.reduce((sum, item) => sum + (Number(item.variant?.price || 0) * Number(this.requirements[item.category] || 1)), 0);
      const savings = Math.round(original * (Number(this.config.percentage || 15) / 100));
      const offer = original - savings;
      this.pricingNode.replaceChildren();
      const value = document.createElement('span');
      value.append('Set value ', Object.assign(document.createElement('s'), {textContent: formatPrice(original)}));
      const total = document.createElement('strong');
      total.textContent = `${formatPrice(offer)} set price`;
      const saving = document.createElement('strong');
      saving.className = 'lus-refill-bundle__saving';
      saving.textContent = `Save ${formatPrice(savings)} today · ${Number(this.config.percentage || 15)}% off`;
      this.pricingNode.append(value, total, saving);
      const needsScent = this.currentCategory !== 'capsule' && !knownScents.includes(this.scent);
      this.button.disabled = needsScent || selections.some(item => !item.variant?.available);
      this.button.textContent = needsScent ? 'Choose a capsule scent to continue' : this.button.disabled ? 'One or more refills are unavailable' : 'Add the refill set · Save 15%';
    }

    async addSet() {
      const selections = this.selectedVariants();
      if ((this.currentCategory !== 'capsule' && !knownScents.includes(this.scent)) || selections.some(item => !item.variant?.available)) return;
      this.setBusy(true, 'Checking your bag…');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
        if (!cartResponse.ok) throw new Error('Cart request failed');
        const cart = await cartResponse.json();
        const familyVariantIds = new Map();
        selections.forEach(({category, product}) => {
          (product?.variants || []).forEach(variant => {
            if (modelFromText([variant.title, ...(variant.options || [])].join(' ')) === this.model) familyVariantIds.set(Number(variant.id), category);
          });
        });
        const present = {capsule: 0, microfibre: 0, ceramic: 0};
        (cart.items || []).forEach(item => {
          const category = familyVariantIds.get(Number(item.variant_id));
          if (category) present[category] += Number(item.quantity || 0);
        });
        const properties = {
          _luscentra_refill_offer: 'refill-set-15',
          _luscentra_refill_source: 'pdp-bundle',
          _luscentra_shower_type: this.model,
        };
        const items = selections.map(item => {
          const quantity = Math.max(0, Number(this.requirements[item.category] || 1) - present[item.category]);
          return quantity ? {id: item.variant.id, quantity, properties} : null;
        }).filter(Boolean);
        if (!items.length) {
          this.setBusy(false, 'Your complete refill set is already in the bag.');
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        const sectionIds = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-drawer', 'cart-icon-bubble'];
        const response = await fetch(window.routes?.cart_add_url || `${root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({items, sections: sectionIds, sections_url: window.location.pathname}),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart request failed');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event: 'refill_pdp_bundle_added', shower_type: this.model, refill_categories_added: items.length, refill_bundle_discount: 15});
        const freshPayload = await freshCartPayload(drawer, items[0]?.id);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'refill-pdp-bundle', cartData: freshPayload});
        if (drawer?.renderContents) {
          drawer.setActiveElement?.(document.activeElement);
          drawer.renderContents(freshPayload);
        }
        this.setBusy(false, 'The compatible refill set was added to your bag.');
      } catch (_) {
        this.setBusy(false, 'We could not add the refill set. Please try again.');
      }
    }

    setBusy(busy, message) {
      this.toggleAttribute('aria-busy', busy);
      if (this.button) this.button.disabled = busy;
      if (this.status) this.status.textContent = message;
      if (!busy) this.render();
    }
  }

  if (!customElements.get('luscentra-refill-pdp-bundle')) customElements.define('luscentra-refill-pdp-bundle', LuscentraRefillPdpBundle);

  function syncProduct() {
    const root = document.querySelector('[data-refill-root]');
    if (!root) return;
    const model = productModel(root);
    root.dataset.refillModel = model;
    const variant = selectedVariant(root);
    if (variant) {
      root.querySelectorAll('.product-variant-id').forEach(input => {
        input.value = variant.id;
        input.disabled = !variant.available;
      });
    }
    root.querySelectorAll('[data-refill-sku]').forEach(node => { node.textContent = variant?.sku || 'Not assigned'; });
    syncVisualSelectors(root, model);
    syncVariantUrl(root, model);
    const scent = selectedScent(root);
    syncCapsuleGallery(root, model, scent);
    syncPage(model, scent);
    document.querySelectorAll('luscentra-refill-pdp-bundle').forEach(bundle => bundle.sync?.(model, scent, variant));
  }

  function mount() {
    const root = document.querySelector('[data-refill-root]');
    if (!root) return;
    if (hasModelChoice(root)) {
      const search = new URLSearchParams(location.search);
      const requested = search.get('model');
      const requestedScentValue = normalise(search.get('scent'));
      const requestedScent = knownScents.includes(requestedScentValue) ? requestedScentValue : '';
      let stored = '';
      try { stored = sessionStorage.getItem('luscentra-model') || ''; } catch (_) {}
      const model = ['handheld', 'wall-mount'].includes(requested) ? requested : !search.has('variant') && ['handheld', 'wall-mount'].includes(stored) ? stored : '';
      if (model) {
        const variant = requestedVariant(root, model, requestedScent);
        const currentId = selectedVariant(root)?.id;
        if (variant && String(variant.id) !== String(currentId)) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          url.searchParams.set('model', model);
          if (requestedScent) url.searchParams.set('scent', requestedScent);
          else url.searchParams.delete('scent');
          location.replace(`${url.pathname}${url.search}`);
          return;
        }
        chooseModel(root, model);
      }
    }
    syncProduct();
    document.querySelectorAll('[data-refill-routine]').forEach(routine => routine.querySelectorAll('[data-refill-model-button]').forEach(button => button.addEventListener('click', () => syncRoutine(routine, button.dataset.refillModelButton, selectedScent(root)))));
  }

  document.addEventListener('change', event => { if (event.target.closest('[data-refill-root]')) setTimeout(syncProduct, 250); });
  document.addEventListener('DOMContentLoaded', mount);
  if (document.readyState !== 'loading') mount();
})();

});